import React, { useState, useEffect, useRef } from "react";
import { Table,  Button, Spinner, Alert } from "react-bootstrap";
import './Table.css';

const UserTable = ({setTableHeight}) => {
    const [users, setUsers] = useState([]); // Initially empty array
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const tableRef = useRef(null);

    const rowsPerPage = 5;
    const [currentPage, setCurrentPage] = useState(1);

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const response = await fetch("https://ridehire-backend-2.onrender.com/user/getAllUSer");
                if (!response.ok) {
                    throw new Error("Failed to fetch data");
                }
                const data = await response.json();
                console.log(data ,"data");

                // Ensure data is an array before setting state
                if (Array.isArray(data.data)) {
                    setUsers(data.data);
                } else {
                    throw new Error("API response is not an array");
                }
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };
        fetchUsers();
    }, []);

    useEffect(() => {
        if (tableRef.current) {
            setTableHeight(tableRef.current.clientHeight);
        }
    }, [loading, users, setTableHeight]);

    const totalPages = Math.ceil(users.length / rowsPerPage);
    const paginatedUsers = users.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);
    const emptyRows = rowsPerPage - paginatedUsers.length;
    



    return (
        <div className="p-0 bg-white">
            <div className="table-responsive border border-2 rounded p-3 shadow">
                <div className="d-flex">
                    <div className="deals-line"></div>
                    <h5 className="fw-bold text-dark mb-4 head-title">Deals Statistics</h5>
                </div>

                {error && <Alert variant="danger">{error}</Alert>}

                {loading ? (
                    <div className="text-center my-4">
                        <Spinner animation="border" variant="primary" />
                        <p>Loading Users...</p>
                    </div>
                ) : (
                    <Table striped bordered hover className="mb-0">
                        <thead className="bg-light">
                            <tr>
                                <th>User ID</th>
                                <th>User Image</th>
                                <th>Full Name</th>
                                <th>Email</th>
                                <th>Mobile</th>
                                <th>City</th>
                                <th>State</th>
                                <th>Country</th>
                            </tr>
                        </thead>
                        <tbody style={{ height: "250px" }}>
                            {paginatedUsers.map((user) => (
                                <tr key={user.id} style={{ height: "50px", fontSize: "14px" }}>
                                    <td className="align-middle">{user.userId}</td>
                                    <td className="align-middle text-center">
                                        <img src={`https://ridehire-backend-2.onrender.com${user.user_Img}`} alt={user.fName} className="rounded-circle shadow" style={{ width: "40px" }} />
                                    </td>
                                    <td className="align-middle">{user.user_fName} {user.user_lName} </td>
                                    <td className="align-middle">{user.user_email}</td>
                                    <td className="align-middle">{user.user_moNo}</td>
                                    <td className="align-middle">{user.user_city}</td>
                                    <td className="align-middle">{user.user_state}</td>
                                    <td className="align-middle">{user.user_country}</td>
                                </tr>
                            ))}

                            {/* Fill empty rows to maintain height */}
                            {emptyRows > 0 &&
                                [...Array(emptyRows)].map((_, i) => (
                                    <tr key={`empty-${i}`} style={{ height: "50px" }}>
                                        <td colSpan="8"></td>
                                    </tr>
                                ))}
                        </tbody>
                    </Table>
                )}
            </div>

            {/* Pagination Controls */}
            <div className="d-flex justify-content-end mt-3">
                <Button
                    variant="success"
                    className="me-2"
                    onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                    disabled={currentPage === 1}
                >
                    Prev
                </Button>
                {[...Array(totalPages)].map((_, i) => (
                    <Button
                        key={i}
                        variant={currentPage === i + 1 ? "primary" : "outline-secondary"}
                        className="mx-1"
                        onClick={() => setCurrentPage(i + 1)}
                    >
                        {i + 1}
                    </Button>
                ))}
                <Button
                    variant="success"
                    className="ms-2"
                    onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                    disabled={currentPage === totalPages}
                >
                    Next
                </Button>
            </div>
        </div>
    );
};

export default UserTable;
